import { render, staticRenderFns } from "./topAfter.vue?vue&type=template&id=0552e8fc&scoped=true&"
import script from "./topAfter.vue?vue&type=script&lang=js&"
export * from "./topAfter.vue?vue&type=script&lang=js&"
import style0 from "./topAfter.vue?vue&type=style&index=0&id=0552e8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0552e8fc",
  null
  
)

export default component.exports